module.exports = __webpack_public_path__ + "static/img/inverted-ramp-8m-x-4m_256.f56663c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inverted-ramp-8m-x-4m_256.png
// module id = U4Lf
// module chunks = 0